import Framework, { shapes } from '@greenville/framework';
import { Container } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';
import HomeIcon from '@mui/icons-material/Home';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import _ from 'lodash';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Route, Switch } from 'react-router-dom';
import env from '../../common/env';
import utils from '../../common/utils';
import LinkMenu from '../../common/components/linkMenu';
import * as constants from '../../common/constants';
import Header from '../../common/header/Header';
import ChatGptUtility from './components/ChatGptUtility';
import ChatGptUtilityFeeback from './components/ChatGptUtilityFeeback';
import ChatGptUtilityTrends from './components/ChatGptUtilityTrends';
import ChannelsComponent from './components/channels/ChannelsComponent';
import ChannelsFeedback from './components/channels/ChannelsFeedback';
import ChannelsTrends from './components/channels/ChannelsTrends';
import ChatDataToc from './components/datagrid/ChatDataToc';
import TenantList from './components/tenantList/TenantList';
import McqSearch from './components/titleSearch/McqSearch';
import TooltipCustom from '../../common/components/TooltipCustom';
import ChatgptConfig from '../../common/config/ChatgptConfig';
import AdminView from './components/AdminView';
import DynamicComponent from './components/DynamicComponent/DynamicComponent';
import AdminPromptView from './components/admin/AdminPromptView';
import UsersPermissions from '../users/models/UsersPermissions';
import EffectivenessMainComponent from './components/effectiveness/EffectivenessMainComponent';
import UserId from '../users/models/UserId';
import TenantFeatureGrid from './components/tenantFeature/TenantFeatureGrid';
import UserPermissionCheck from './models/UserPermissionCheck';
import TenantConfigModel from './models/TenantConfig';

const styles = {
  contentWrapper: {
    position: 'relative',
    width: '100%',
    margin: '0 auto',
    top: 75
  },
  buttonStyle: {
    marginLeft: '35px'
  },
  IconButtonStyle: {
    width: '30px',
    height: '30px'
  }
};
const breadcrumbStyles = {
  color: '#252525',
  fontSize: '16px',
  fontFamily: 'Open Sans, Calibri, Tahoma, sans-serif',
  fontWeight: '400',
  lineHeight: '1.25'
};

const activeBreadcrumbStyles = {
  fontWeight: 'bold',
  color: '#252525'
};

@inject(
  'chatgptUtility',
  'channelsUtility',
  'chatgptSummaryUtility',
  'chatgptAdminPrompts',
  'language',
  'userPermissions',
  'fileDataService',
  'tenantConfig',
  'userPermissionCheck',
  'userid'
)
@observer
class ChatGptUtilityContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    language: shapes.language.isRequired,
    userPermissions: shapes.modelOf(UsersPermissions).isRequired,
    tenantConfig: shapes.modelOf(TenantConfigModel).isRequired,
    userid: shapes.modelOf(UserId).isRequired,
    userPermissionCheck: shapes.modelOf(UserPermissionCheck).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      tabName: '',
      tenantName: '',
      tokenValue: ''
      // tabState: '',
    };
  }

  componentDidMount() {
    this.tabHandler();
  }

  componentDidUpdate(prevProps, prevState) {
    const { tenantConfig, userid } = this.props;
    const { tokenValue } = this.state;
    const { data } = toJS(tenantConfig);
    if (data.length > 0) {
      this.setPermissionFlag(userid?.userdetails?.tenantId, data);
    }
    if (prevState.tokenValue !== tokenValue && _.isEmpty(data)) {
      this.getTenantsConfig();
    }
  }

  setPermissionFlag = async (tenantId, tenantItems) => {
    const selectedTabName = window.location.pathname.split('/')[2];
    const tenantData = tenantItems.find((data) => data.name === selectedTabName);
    if (tenantData?.tenantId && tenantId) {
      const tenantIds = tenantId.split(',');
      if (tenantIds.includes(tenantData.tenantId)) {
        Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: true });
      } else {
        Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: false });
      }
    } else {
      Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: true });
    }
  };

  getTenantsConfig = async () => {
    const { tokenValue } = this.state;
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.post(
      `${env.EVERGREEN_API_BASE_URL}${constants.GET_TENANTS_CONFIG_DATA_URL}`,
      {},
      { headers }
    );
    if (response && response.data && response.data.data) {
      Framework.getStoreRegistry().getStore('tenantConfig').setResponse(response.data);
    }
  };

  handleTenantName = (tenant) => {
    const searchData = ChatgptConfig.tenantData.find((data) => data.name === tenant);
    const tabName = searchData?.tabDetails[0]?.tabUrl;
    this.setState({
      tenantName: tenant,
      tabName
    });
  };

  handleBreadcrumbClick = () => {
    // console.log('am clicked', path);
  };

  handleChange = () => {
    const { history } = this.props;
    this.setState({
      tabName: ''
    });
    history.push('/chatgptutility');
  };

  handleTabChange = (e, value) => {
    // const { language } = this.props;
    this.setState({
      tabName: value
    });
  };

  hanleTenantHeader = () => {
    const { history, tenantConfig } = this.props;
    const { data } = toJS(tenantConfig);
    const selectedTenantName = history.location.pathname.split('/');
    // eslint-disable-next-line prefer-destructuring
    const tenantName = selectedTenantName[2];
    const tenanObj = data.find((item) => item.name === tenantName);
    return [{ title: tenanObj?.title }];
  };

  tabHandler() {
    const { history } = this.props;
    const { tenantName } = this.state;
    const searchData = ChatgptConfig.tenantData.find(
      (data) => data.name === tenantName || history.location.pathname.split('/')[2]
    );
    const tabName = history.location.pathname.split('/')[3] || searchData?.tabDetails[0]?.tabUrl;
    this.setState({
      tabName,
      tenantName: tenantName || history.location.pathname.split('/')[2]
    });
  }

  checkPermissions(checkList) {
    const { userPermissions } = this.props;
    const permissionsList = toJS(userPermissions.permissionList.permissions) || [];
    if (checkList.length === 0) return true; // if no permission required then return true
    return checkList.some((permission) => permissionsList.includes(permission));
  }

  render() {
    const { classes, history, language } = this.props;
    const { tabName, tokenValue, tenantName } = this.state;
    const activeSession = utils.getSessionData();
    if (activeSession !== null && tokenValue === '') {
      const token = utils.getToken();
      this.setState({
        tokenValue: token
      });
    }
    const renderTenantWiseTab = () => {
      const searchData = ChatgptConfig.tenantData.find((data) => data.name === tenantName);
      const tabDetails = searchData?.tabDetails || [];
      return tabDetails
        .filter((item) => this.checkPermissions(item?.permissionsRequired))
        .map((item) => (
          <Tab
            key={item.tabUrl}
            value={item.tabUrl}
            label={
              <TooltipCustom title={<FormattedMessage {...language.getText(item.toolTipTitle)} />}>
                <span>{item.tabName}</span>
              </TooltipCustom>
            }
            component={Link}
            to={`/chatgptutility/${tenantName}/${item.tabUrl}`}
          />
        ));
    };

    const locationPath = ['/chatgptutility', '/chatgptutility/'];
    return (
      <>
        <Header />
        <main className={classes.contentWrapper} id="mainContent" role="main">
          {!history.location.pathname.includes('/chatgptutility/aistudytools/mcq') &&
            !history.location.pathname.includes('/chatgptutility/aistudytools/summary') &&
            !history.location.pathname.includes(`/chatgptutility/${tenantName}/mcq`) &&
            !history.location.pathname.includes(`/chatgptutility/${tenantName}/summary`) &&
            // !history.location.pathname.includes('/chatgptutility/aistudytools/titlesearch') &&
            !history.location.pathname.includes('/chatgptutility/admin') &&
            !locationPath.includes(history.location.pathname) && (
              <Stack direction="row" className={classes.buttonStyle} alignItems="center">
                <TooltipCustom title={<FormattedMessage {...language.getText('chatUtility.HOME')} />}>
                  <IconButton size="large" color="primary" aria-label="HOME" onClick={() => this.handleChange()}>
                    <HomeIcon sx={{ fontSize: '30px' }} />
                  </IconButton>
                </TooltipCustom>
                <LinkMenu
                  paths={this.hanleTenantHeader()}
                  separator="/"
                  onClick={this.handleBreadcrumbClick}
                  styles={breadcrumbStyles}
                  activeStyle={activeBreadcrumbStyles}
                />
              </Stack>
            )}
          <Container maxWidth="xl">
            {!history.location.pathname.includes('/chatgptutility/aistudytools/mcq') &&
              !history.location.pathname.includes('/chatgptutility/aistudytools/summary') &&
              !history.location.pathname.includes(`/chatgptutility/${tenantName}/mcq`) &&
              !history.location.pathname.includes(`/chatgptutility/${tenantName}/summary`) &&
              // !history.location.pathname.includes('/chatgptutility/aistudytools/titlesearch') &&
              !history.location.pathname.includes('/chatgptutility/admin') &&
              // !history.location.pathname.includes('/chatgptutility/aistudytools/promptmgt') &&
              // !history.location.pathname.includes('/chatgptutility/channels/promptmgt') &&
              !locationPath.includes(history.location.pathname) && (
                <>
                  <Paper elevation={3}>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={tabName}
                        onChange={(e, newValue) => this.handleTabChange(e, newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="Workflow Status Tabs"
                      >
                        {renderTenantWiseTab()}
                      </Tabs>
                    </AppBar>
                  </Paper>
                  <br />
                </>
              )}
            <Switch>
              <Route
                path="/chatgptutility/aistudytools"
                exact
                render={() => <ChatGptUtility tenantName={tenantName} {...this.props} />}
              />
              <Route
                path="/chatgptutility/aistudytools/auditlog"
                exact
                render={() => <ChatGptUtility tenantName={tenantName} {...this.props} />}
              />

              <Route
                path="/chatgptutility/aistudytools/feedback"
                exact
                render={() => <ChatGptUtilityFeeback {...this.props} />}
              />

              <Route
                path="/chatgptutility/aistudytools/trends"
                exact
                render={() => <ChatGptUtilityTrends {...this.props} />}
              />

              <Route
                path="/chatgptutility/aistudytools/trends/charts"
                exact
                render={() => <ChatGptUtilityTrends {...this.props} />}
              />

              <Route
                path="/chatgptutility/aistudytools/trends/clustering"
                exact
                render={() => <ChatGptUtilityTrends {...this.props} />}
              />

              <Route
                path="/chatgptutility/aistudytools/mcq/view/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path="/chatgptutility/aistudytools/mcq/add/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path="/chatgptutility/aistudytools/mcq/edit/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewviewType="quiz" />}
              />
              <Route
                path="/chatgptutility/aistudytools/mcq"
                exact
                render={() => <ChatDataToc viewType="quiz" tenantName={tenantName} />}
              />
              {/* <Route path="/chatgptutility/mcq/edit" exact render={() => <McqEditQuestionDialog />} />
              <Route path="/chatgptutility/mcq/add" exact render={() => <TocAddDialog />} /> */}
              <Route
                path="/chatgptutility/aistudytools/summary/view/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" tenantName={tenantName} />}
              />
              <Route
                path="/chatgptutility/aistudytools/summary/add/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" />}
              />
              <Route
                path="/chatgptutility/aistudytools/summary/edit/:bookId"
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" />}
              />
              <Route
                path="/chatgptutility/aistudytools/summary"
                exact
                render={() => <ChatDataToc viewType="summary" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/mcq`}
                exact
                render={() => <ChatDataToc viewType="quiz" tenantName={tenantName} />}
              />

              <Route
                path={`/chatgptutility/${tenantName}/summary`}
                exact
                render={() => <ChatDataToc viewType="summary" tenantName={tenantName} />}
              />

              <Route
                path="/chatgptutility/aistudytools/trends/unanswered"
                exact
                render={() => <ChatGptUtilityTrends {...this.props} />}
              />

              <Route
                path={`/chatgptutility/${tenantName}/mcq/view/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/mcq/add/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/mcq/edit/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/mcq`}
                exact
                render={() => <ChatDataToc viewType="quiz" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/summary/view/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/summary/add/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/summary/edit/:bookId`}
                exact
                render={() => <ChatDataToc {...this.props} viewType="summary" tenantName={tenantName} />}
              />
              <Route
                path={`/chatgptutility/${tenantName}/summary`}
                exact
                render={() => <ChatDataToc viewType="summary" tenantName={tenantName} />}
              />

              <Route path="/chatgptutility/aistudytools/titlesearch" exact render={() => <McqSearch />} />
              <Route path="/chatgptutility/rplus/titlesearch" exact render={() => <McqSearch />} />
              <Route path="/chatgptutility/activehub/titlesearch" exact render={() => <McqSearch />} />
              <Route
                path="/chatgptutility"
                exact
                render={() => <TenantList handleTenantName={this.handleTenantName} />}
              />
              <Route path="/chatgptutility/channels" exact render={() => <ChannelsComponent />} />
              <Route path="/chatgptutility/channels/auditlog" exact render={() => <ChannelsComponent />} />
              <Route path="/chatgptutility/channels/feedback" exact render={() => <ChannelsFeedback />} />
              <Route path="/chatgptutility/channels/trends" exact render={() => <ChannelsTrends {...this.props} />} />
              <Route path="/chatgptutility/admin" exact render={() => <AdminView />} />
              {/* <Route path="/chatgptutility/aistudytools/reports" exact render={() => <ReportsComponent />} />
              <Route path="/chatgptutility/channels/reports" exact render={() => <ReportsComponent />} /> */}
              <Route path="/chatgptutility/aistudytools/promptmgt" exact render={() => <AdminPromptView />} />
              <Route
                path={`/chatgptutility/${tenantName}/promptmgt/effectiveness`}
                exact
                render={() => <EffectivenessMainComponent />}
              />
              <Route path="/chatgptutility/channels/promptmgt" exact render={() => <AdminPromptView />} />
              <Route path="/chatgptutility/aistudytools/configuration" exact render={() => <TenantFeatureGrid />} />
              <Route path="/chatgptutility/channels/configuration" exact render={() => <TenantFeatureGrid />} />
              <Route path="/chatgptutility/pvs/configuration" exact render={() => <TenantFeatureGrid />} />
              <Route
                path="/chatgptutility/*"
                render={() => <DynamicComponent {...this.props} selectedTabValue={tabName} />}
              />
            </Switch>
          </Container>
        </main>
      </>
    );
  }
}

export default withStyles(styles)(ChatGptUtilityContainer);
